module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#home",
      toString: function () {
        return this.url;
      }
    }